<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file ImageResponsive.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  ImageResponsive.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <img :data-src="main"
         ref="image_ref"
         :class="{
            'lazyload blur-up':lazy_load
         }"
         :alt="alt">
    <!--        <picture>-->
    <!--            <template v-if="image.image_data.srcset">-->
    <!--                <template v-for="imageSrc in image.image_data.srcset">-->
    <!--                    <source-->
    <!--                            :media="`(min-width:${imageSrc.width}px)`"-->
    <!--                            :srcset="`${cdnUrl()}${imageSrc.src} ${imageSrc.width}w`"-->
    <!--                    >-->
    <!--                </template>-->
    <!--                <img :src="main"-->
    <!--                     alt="">-->
    <!--            </template>-->
    <!--            <template v-else>-->
    <!--                <img :src="main"-->
    <!--                     alt="">-->
    <!--            </template>-->
    <!--        </picture>-->
</template>

<script>
    import 'lazysizes'
    import {HUB, CDN_URL, BUCKET_NAME, IMAGE_URL_BASE} from '../../config/config';
    import {createMainImage} from '../../../../../app/Shared/Resources/Assets/js/helpers/images';

    export default {
        name: "ImageResponsive",
        props: {
            /**
             * @param Object image.image_data
             * @param Object image
             */
            alt: {
                type: String,
                default: ''
            },
            image: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            lazy_load: {
                type: Boolean,
                default: true
            },
            default_size: {
                type: String,
                default: 'md'
            },
            ratio: {
                type: Object,
                default: () => {
                    return {
                        w: 16,
                        h: 9
                    }
                }
            },
            /**
             * When using a grid then we want to consider the viewport is taken into account and
             * an appropriate image is chosen to fit the viewport NOT the grid item
             * so we will use a default of 4 grids per row
             *
             * if the viewport is 1024 wide then we should choose an image size that is that / 4
             */
            use_grid: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                sizes: {
                    xl: 600,
                    lg: 600,
                    md: 600,
                    sm: 600,
                    xs: 600
                },
                main: '',
                sourceSet: '',
                sizesSet: '',
                height: 300
            }
        },
        mounted() {
            let self = this;

            self.main = self.image === null ? self.readDefaultImage() : self.cdnUrl() + self.image.url;
            if (self.image !== null) {
                if (self.image.image_data.srcset) {
                    self.sourceSet = self.createSrcSet().sources;
                    self.sizesSet = self.createSrcSet().sizes;
                    self.height = self.setRatioHeight(self.image.image_data.srcset[self.default_size])
                }

                if(self.lazy_load){
                    self.$refs.image_ref.setAttribute('data-srcSet',self.sourceSet);
                    self.$refs.image_ref.setAttribute('data-sizes',self.sourceSet);
                }else{
                    self.$refs.image_ref.setAttribute('srcSet',self.sourceSet);
                    self.$refs.image_ref.setAttribute('sizes',self.sourceSet);
                }
            }
        },
        methods: {
            setRatioHeight(w) {
                let self = this,
                    divisor = w / self.ratio.w;

                return divisor * self.ratio.h;

            },
            setGridStandard(images, src) {
                let self = this;

                if (!self.use_grid) {
                    return images[src].width;
                }
                switch (self.default_size) {
                    case 'xl':
                        return images.md.width;
                    case 'lg':
                        return images.sm.width;
                    case 'sm':
                        return images.sm.width;
                    case 'xs':
                        return images.xs.width;
                    case 'tiny':
                        return images.tiny.width;

                    default:
                        return images.md.width;
                }
            },
            cdnUrl() {
                return CDN_URL + '/' + BUCKET_NAME + '/';
            },
            createSrcSet() {
                let self = this,
                    cdn = self.cdnUrl(),
                    sources = [],
                    sizes = [],
                    /**
                     * @param image.image_data
                     */
                    images = self.image.image_data;

                for (let src in images.srcset) {
                    let image = images.srcset[src],
                        width = self.setGridStandard(images.srcset, src),
                        sourceSet = `${cdn}${image.src} ${image.width}w`,
                        sizesSet = `(max-width:${image.width}px) ${width}px `;
                    sources.push(sourceSet);
                    sizes.push(sizesSet);
                }

                let mainImageMaxSize = self.setGridStandard(images.srcset, 'lg');
                sizes.push(mainImageMaxSize + 'px');

                return {
                    sources: sources.join(','),
                    sizes: sizes.join(','),
                };
            },
            readDefaultImage() {
                return IMAGE_URL_BASE.default_image_url;
            },
            createImageUrl(record) {
                // let imageModel = readImageFromData(record);
                let imageModel = createMainImage(record);

                // console.log('createImageUrl', 'record',record);
                if (typeof imageModel !== 'undefined' && imageModel !== null) {
                    return `${imageModel}`
                }

            },
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/images/ImageResponsive.vue